module.exports = {"id":"194728","name":"Ishak Belfodil","rating":"75","photo":"./data/images/photos/4/194728.png","club":{"name":"Werder Brême","logo":"./data/images/clubs/WerderBreme.png"},"positions":["BU","MG","ATT"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/IshakBelfodil0.json
// module id = 1820
// module chunks = 0